import * as React from 'react';

function Oddsboost(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
      <rect width={16} height={16} rx={1.391} fill="#D70022" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 8.161h2.574L5.04 11.362H8.9l1.026-3.2H12.5L9.795 2.5 3.5 8.161zm.865 5.339h3.861l.201-.634H4.566l-.201.634zm4.404-1.708H4.908l-.181.602h3.861l.181-.602z"
        fill="white"
      />
    </svg>
  );
}

export default Oddsboost;
